module.exports = __webpack_public_path__ + "static/img/image_flotte.a212659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image_flotte.jpg
// module id = 9FPE
// module chunks = 1